function getFacebookAuthLinkFeatureFlags(): {
  facebookAuthHide: boolean;
  facebookAuthLink: boolean;
} {
  if (typeof window === 'undefined') {
    return {
      facebookAuthHide: false,
      facebookAuthLink: false,
    };
  }

  const rawInitialState = window.__INITIAL_STATE_UNPARSED__
    ? JSON.parse(window.__INITIAL_STATE_UNPARSED__)
    : window.__INITIAL_STATE__;

  return {
    facebookAuthHide: rawInitialState.facebook_auth_hide,
    facebookAuthLink: rawInitialState.facebook_auth_link,
  };
}

export default getFacebookAuthLinkFeatureFlags;
